import { Component, Input } from "@angular/core";

@Component({
    selector: 'corp-tab',
    templateUrl: './corp-tab.component.html',
    standalone: true,
    imports: []
  })
  export class CorpTabComponent {
    @Input('tabTitle') title: string | null = null;
    @Input() active = false;
  }